import React from 'react';
import { ReactComponent as HelpdocIcon } from 'assets/icons/helpdocs.svg';
import styles from './HelpCenter.module.css';
import classNames from 'classnames';

export const HelpCenter = ({
  helpLink,
  className,
}: {
  helpLink: string;
  className?: string;
}) => (
  <div
    className={classNames(styles.help, className)}
    onClick={() => window.open(helpLink, '_blank')}
  >
    <HelpdocIcon className={styles.helpIcon} />
    Help Сenter
  </div>
);
